const CSS_CLASSES = {
	CONTAINER: 'text-field__container',
	LABEL: 'text-field__label',
};

export { CSS_CLASSES };
